import React from 'react'
import Header from '../../../Components/Header'

function ReRolls({ heading_size = 2 }) {
    return (
        <>
            <Header text={"ReRolls"} level={heading_size}/>
            <div>
                Data
            </div>
        </>
    )
}

export default ReRolls